/**
 * Шкала слоёв интерфейса (`z-index`) — ОДНО место на всё приложение.
 *
 * Раньше её не было: сорок с лишним мест писали число «на глаз», и слои
 * встречались друг с другом случайно. Так и вылез дефект, ради которого этот
 * файл заведён: выпадающее меню шапки жило на уровне `1`, а содержимое страницы
 * — на `2`, `3`, `4`, `20`, `30`, `50`, `100`, и любое из них рисовалось ПОВЕРХ
 * раскрытого меню.
 *
 * Как читать шкалу — снизу вверх, каждый слой обязан быть выше предыдущего:
 *
 *   содержимое страницы   ≤ CONTENT_MAX (100)
 *   шапка с меню          = HEADER (500)
 *   накладки поверх всего = MODAL (1000) < TOAST < COMMAND_PALETTE
 *
 * 🔴 Содержимое страницы заперто в своём слое: `ContentWrapper` в
 * `templates/MainTemplate` объявлен `isolation: isolate`. Поэтому число внутри
 * страницы физически не может всплыть над шапкой — даже `9999`. `CONTENT_MAX`
 * нужен не для этого, а чтобы внутри содержимого не воевали случайные числа;
 * его соблюдение стережёт тест `__tests__/layers.guard.test.ts`.
 *
 * Значения antd v4 (`node_modules/antd/lib/style/themes/default.less`) —
 * не наши, но соседние по шкале, и их полезно видеть рядом:
 *
 *   @zindex-table-fixed 2 · @zindex-affix 10 · @zindex-modal 1000
 *   @zindex-message/notification 1010 · @zindex-popover 1030
 *   @zindex-dropdown / @zindex-picker 1050 · @zindex-popoconfirm 1060
 *   @zindex-tooltip 1070 · @zindex-image 1080
 *
 * Все поповеры antd уходят в `document.body` (`getPopupContainer` в проекте не
 * задан нигде), поэтому они выше шапки и по числу, и по порядку в DOM — так и
 * должно быть: список селекта обязан накрывать шапку, а не прятаться под ней.
 */
export const LAYERS = {
  /**
   * Потолок для всего, что живёт внутри страницы: липкие шапки таблиц,
   * подсказки, самописные выпадашки на экранах.
   */
  CONTENT_MAX: 100,
  /**
   * Шапка с главным меню. Выше любого содержимого и ниже любой накладки —
   * между `CONTENT_MAX` и `MODAL`. Менять это число можно только вместе с
   * соседями по шкале.
   */
  HEADER: 500,
  /** Собственный скрим `atoms/Modal`. Совпадает с antd `@zindex-modal`. */
  MODAL: 1000,
  /** Тосты — поверх модалки: сообщение об ошибке нужно видеть и над диалогом. */
  TOAST: 1001,
  /** Палитра команд (Cmd+K) — самый верх, её вызывают из любого состояния. */
  COMMAND_PALETTE: 1100,
} as const;
